<template>
  <header class="app-header">
    <user-menu @onToggle="$emit('onToggleSidebar')" :show-sidebar="showSidebar"/>
    <translation @onToggleTranslation="$emit('onToggleTranslation')"/>
    <app-source />
    <page-header />
    <div :class="`header-button-wrap ${wrapShow()}`">
      <back-button />
      <print-button @onClick="switchPrintMethod"/>
    </div>
   <feeds-list :translation-play="translationPlay"/>
  </header>
</template>

<script>
// components
import UserMenu from "./components/UserMenu.vue";
import Translation from "./components/Translation.vue";
import AppSource from "./components/Source.vue";
import PageHeader from "./components/PageHeader.vue";
import FeedsList from "./components/FeedsList.vue";
import BackButton from './components/BackButton.vue';
import PrintButton from './components/PrintButton.vue';

export default {
  name: "AppHeader",
  props: {
    showSidebar: {
      type: Boolean
    },
    translationPlay: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      onRoute: '',
    }
  },
  methods: {
    wrapShow() {
      return this.onRoute !== 'threadId' ? 'header-button-wrap--show' : '';
    },
    switchPrintMethod() {
      if (this.onRoute) {
        this[this.methods[this.onRoute]]();
      }
    }
  },
  mounted() {
    this.onRoute = this.$route.name;
  },
  watch: {
    $route(route) {
      this.onRoute = route.name;
    },
  },
  components: {
    UserMenu,
    Translation,
    AppSource,
    PageHeader,
    FeedsList,
    BackButton,
    PrintButton
  }
};
</script>

<style>
.app-header {
  position: relative;
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-bottom: 15px;
  width: 100%;
  height: 66px;
  border-bottom: 1px solid #c4c4c4;
  box-sizing: border-box;
}

.header-button-wrap {
  display: none;
}

.header-button-wrap--show {
  display: none;
}

@media (max-width: 1360px) {
  .header-button-wrap--show {
    display: none;
  }
}

@media (max-width: 1040px) {
  .header-button-wrap--show {
    display: flex;
  }
}

@media (max-width: 760px) {
  .app-header {
    position: relative;
    width: 100%;
    height: 120px;
    padding-top: 20px;
    margin: 0 5px 0 5px;
    align-items: flex-start;
  }

  .header-button-wrap {
    margin-top: -5px;
  }
}

</style>
